import ModalAsset from '@/components/sections/builder/settings/modal-asset';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import useModal from '@/hooks/useModal';
import { ChevronDown, PlusIcon, Trash2Icon, RefreshCwIcon } from 'lucide-react';
import Image from 'next/image';

type ImageSettingType = {
  value?: string;
  onChange?: (value?: string) => void;
};

export default function ImageSetting({ value, onChange }: ImageSettingType) {
  const selectImageModal = useModal<string>();

  if (!value) {
    return (
      <>
        <button
          type='button'
          onClick={() => {
            selectImageModal.open(value);
          }}
          className='flex aspect-[16/9] w-full cursor-pointer items-center justify-center gap-x-2 rounded-lg border border-dashed border-[#AEABAB] duration-300 hover:bg-stone-100'
        >
          <PlusIcon className='h-4 w-4 text-[#45464E]' />
          <span>Select Image</span>
        </button>
        <ModalAsset
          initialValue={value}
          openModal={selectImageModal.isShow}
          setOpenModal={(e) => !e && selectImageModal.setIsShow(e)}
          onSelect={(imageUrl) => {
            onChange?.(imageUrl);
            selectImageModal.close();
          }}
        />
      </>
    );
  }

  return (
    <>
      <div className='rounded-md bg-gray-50 py-4'>
        <Image
          className='aspect-[16/9] w-full cursor-pointer border-[#AEABAB] object-contain duration-300 hover:bg-stone-100'
          src={value}
          alt='Images'
          width={268}
          height={150}
        />
        <div className='mt-4 px-4'>
          <DropdownMenu modal={false}>
            <DropdownMenuTrigger asChild>
              <Button type='button' variant='outline' className='flex w-full gap-x-2 bg-white'>
                <span>Change</span>
                <ChevronDown className='h-4 w-4' />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className='w-full'>
              <DropdownMenuItem
                onClick={() => {
                  selectImageModal.open(value);
                }}
              >
                <RefreshCwIcon className='mr-2 h-4 w-4' />
                <div>Change image</div>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => onChange?.()}>
                <Trash2Icon className='mr-2 h-4 w-4' />
                <div>Remove image</div>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      <ModalAsset
        initialValue={value}
        openModal={selectImageModal.isShow}
        setOpenModal={(e) => !e && selectImageModal.setIsShow(e)}
        onSelect={(imageUrl) => {
          onChange?.(imageUrl);
          selectImageModal.close();
        }}
      />
    </>
  );
}
